import request from 'admin-ng/util/request-promise';
import {COMMENTS} from '.';

export const all = (organizationId, params) =>
  request(COMMENTS, 'get', {...params, organization_id: organizationId});
export const create = (organizationId, text) =>
  request(COMMENTS, 'post', {organization_id: organizationId, text});
export const update = (id, text) => request(`${COMMENTS}${id}`, 'put', {text});
export const del = id => request(`${COMMENTS}${id}`, 'del', {});
